__turbopack_context__.v({
  "product-attribute-tile-list": "product-attribute-tile-list-component-module-scss-module__MvCNEa__product-attribute-tile-list",
  "product-attribute-tile-list--scrollable": "product-attribute-tile-list-component-module-scss-module__MvCNEa__product-attribute-tile-list--scrollable",
});
